// extracted by mini-css-extract-plugin
export default {"not-found__space":"style_not-found__space__DI0EA"};